import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const otRequestCreate = createAsyncThunk("otRequestCreate", async ({ data }, { rejectWithValue }) => {
    try {
        console.log("data", data);
        const response = await axiosHttp.post(`requests/overtime`, data);
        return response.data;

    } catch (err) {
        if (!err.response) {
            throw err;
        }
        return rejectWithValue(err.response.data);
    }
});

const otRequestCreateSlice = createSlice({
    name: "otRequestCreateSlice",
    initialState: {
        isLoading: false,
        isError: false,
        error: null,
        data: null,
    },

    reducers: {
        resetCreateState: (state) => {
            state.isLoading = false;
            state.error = false;
            state.data = null;
        },
    },

    extraReducers: (builder) => {
        builder.addCase(otRequestCreate.pending, (state, action) => {
            state.isLoading = true;
            state.isError = false;
        });

        builder.addCase(otRequestCreate.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isError = false;
            state.data = action.payload;
        });

        builder.addCase(otRequestCreate.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action.payload;
        });
    },
});

export const { resetCreateState } = otRequestCreateSlice.actions;
export default otRequestCreateSlice.reducer;
